const root = document.documentElement;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const supportsCrossDocumentTransitions = 'onpageswap' in window && 'onpagereveal' in window;

if (!supportsCrossDocumentTransitions && !reducedMotion.matches && !root.classList.contains('shopify-design-mode')) {
  root.classList.add('foksha-page-transition-fallback');

  window.addEventListener('pageshow', () => {
    root.classList.remove('foksha-page-leaving');
  });

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    const destination = new URL(link.href, window.location.href);
    const current = new URL(window.location.href);
    const isSameDocument =
      destination.pathname === current.pathname &&
      destination.search === current.search &&
      destination.hash;

    if (
      destination.origin !== current.origin ||
      !['http:', 'https:'].includes(destination.protocol) ||
      isSameDocument ||
      destination.pathname.startsWith('/checkout') ||
      link.matches('[data-no-page-transition]')
    ) {
      return;
    }

    event.preventDefault();
    root.classList.add('foksha-page-leaving');

    window.setTimeout(() => {
      window.location.assign(destination.href);
    }, 110);
  });
}
